document.addEventListener('DOMContentLoaded', () => {
  const reviewSections = document.querySelectorAll('[data-reviews-proof]');

  reviewSections.forEach((section) => {
    const slides = Array.from(section.querySelectorAll('[data-review-slide]'));
    const prevButton = section.querySelector('[data-review-nav="prev"]');
    const nextButton = section.querySelector('[data-review-nav="next"]');
    const currentCounter = section.querySelector('[data-review-current]');

    if (slides.length <= 1) {
      return;
    }

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) {
      activeIndex = 0;
    }

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (currentCounter) {
        currentCounter.textContent = String(activeIndex + 1);
      }
    };

    // ------------------------------------------------------------------------
    // Autoplay Engine (4.2s cycle with pause on hover, touch, and visibility)
    // ------------------------------------------------------------------------
    let autoplayTimer = null;
    let isPaused = false;
    let isIntersecting = true;
    const AUTOPLAY_INTERVAL = 4200;

    const startAutoplay = () => {
      stopAutoplay();
      if (isPaused || !isIntersecting) return;
      autoplayTimer = setInterval(() => {
        showSlide(activeIndex + 1);
      }, AUTOPLAY_INTERVAL);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const resetAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    // Pause on desktop hover
    section.addEventListener('mouseenter', () => {
      isPaused = true;
      stopAutoplay();
    });

    section.addEventListener('mouseleave', () => {
      isPaused = false;
      startAutoplay();
    });

    // Pause when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    // Only run autoplay when review section is in or near viewport
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isIntersecting = entry.isIntersecting;
            if (entry.isIntersecting) {
              startAutoplay();
            } else {
              stopAutoplay();
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(section);
    } else {
      startAutoplay();
    }

    prevButton?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      resetAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      resetAutoplay();
    });

    let touchStartX = 0;
    let touchEndX = 0;

    section.addEventListener(
      'touchstart',
      (event) => {
        isPaused = true;
        stopAutoplay();
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    section.addEventListener(
      'touchend',
      (event) => {
        isPaused = false;
        touchEndX = event.changedTouches[0].clientX;
        const delta = touchEndX - touchStartX;

        if (Math.abs(delta) >= 40) {
          if (delta > 0) {
            showSlide(activeIndex - 1);
          } else {
            showSlide(activeIndex + 1);
          }
        }
        startAutoplay();
      },
      { passive: true }
    );

    showSlide(activeIndex);
    startAutoplay();
  });
});
